var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#fff",
    stroke: "#707070",
    transform: "translate(30 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0 0H33V19.131H0z",
    className: "cl-2"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cl-2{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flagEng",
    clipPath: "url(#clip-path)",
    transform: "translate(-30 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flagEnglish",
    transform: "translate(22.963 10.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    clipPath: "url(#clip-path-2)",
    transform: "translate(.037 .422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_69",
    d: "M0 0H33V19.131H0z",
    className: "cl-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    fill: "#c8102e",
    d: "M0 0v1.487l8.434 4.89H11zm14.52 0v7.652H0v3.824h14.52v7.656h3.96v-7.657H33V7.652H18.479V0zm15.913 0L19.8 6.165v.212H22L33 0zM10.971 12.754L0 19.131h2.565L13.2 12.966v-.212zm11.028 0l11 6.377v-1.487l-8.433-4.89z",
    transform: "translate(.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    fill: "#012169",
    d: "M3.861 0L13.2 5.421V0zM19.8 0v5.422L29.152 0zM0 2.231v4.146h7.152zm33 0l-7.151 4.146H33zM0 12.754V16.9l7.151-4.146zm25.852 0L33 16.948v-4.194zm-6.052.956v5.421h9.352zm-6.6 0l-9.351 5.421H13.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flagEN.d4cec017d45574fbf6436221f0b90e8e.svg";
export { ForwardRef as ReactComponent };